module.exports = __webpack_public_path__ + "mo/img/process_4.654d5736.png";